import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PivotGrid, FieldChooser, Export } from 'devextreme-react/pivot-grid';
import config from 'devextreme/core/config';
import saveAs from 'file-saver';
import ExcelJS from 'exceljs';
import { exportPivotGrid } from 'devextreme/excel_exporter';

export default class OBDrillDown extends Component {
    onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('exportedData');

        exportPivotGrid({
            component: e.component,
            worksheet: worksheet,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'exportedData.xlsx');
            });
        }).catch((error) => {
            console.error("Export failed: ", error);
        });
    }

    render() {
        const { setProps, ...pivotGridProps } = this.props;
        config({ licenseKey: this.props.licenseKey });

        return (
            <React.Fragment>
                <PivotGrid
                    {...pivotGridProps}
                    showBorders={true}
                    onExporting={this.onExporting}
                    onCellClick={(e) => {
                        if (setProps) {
                            setProps({
                                cell: {
                                    area: e.area,
                                    cell: {
                                        columnPath: e.cell.columnPath,
                                        dataIndex: e.cell.dataIndex,
                                        expanded: e.cell.expanded,
                                        path: e.cell.path,
                                        rowPath: e.cell.rowPath,
                                        text: e.cell.text,
                                        value: e.cell.value,
                                    },
                                    rowIndex: e.rowIndex,
                                    columnIndex: e.columnIndex,
                                    columnFields: e.columnFields,
                                    rowFields: e.rowFields,
                                    dataFields: e.dataFields,
                                },
                            });
                        }
                    }}
                >
                    <FieldChooser enabled={true} />
                    <Export enabled={true} />
                </PivotGrid>
            </React.Fragment>
        );
    }
}

// Define all PivotGrid PropTypes
OBDrillDown.propTypes = {
    // General Props
    id: PropTypes.string,
    dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rtlEnabled: PropTypes.bool,
    disabled: PropTypes.bool,
    visible: PropTypes.bool,
    elementAttr: PropTypes.object,
    hint: PropTypes.string,
    // PivotGrid specific Props
    allowExpandAll: PropTypes.bool,
    allowFiltering: PropTypes.bool,
    allowSorting: PropTypes.bool,
    allowSortingBySummary: PropTypes.bool,
    dataFieldArea: PropTypes.string,
    disabled: PropTypes.bool,
    fieldChooser: PropTypes.object,
    fieldPanel: PropTypes.object,
    headerFilter: PropTypes.object,
    hideEmptySummaryCells: PropTypes.bool,
    loadPanel: PropTypes.object,
    rowHeaderLayout: PropTypes.string,
    scrolling: PropTypes.object,
    showBorders: PropTypes.bool,
    showColumnGrandTotals: PropTypes.bool,
    showColumnTotals: PropTypes.bool,
    showRowGrandTotals: PropTypes.bool,
    showRowTotals: PropTypes.bool,
    stateStoring: PropTypes.object,
    texts: PropTypes.object,
    wordWrapEnabled: PropTypes.bool,
    // Custom Props
    licenseKey: PropTypes.string,
    cell: PropTypes.object,
    exportTest: PropTypes.object,
    setProps: PropTypes.func,
};
